<template>
  <div class="pc-dialog-wrap">
    <modal name="addPromoCode" @before-close="onClose" class="pc-modal" :adaptive="true" :scrollable="true" height="auto" width="90%" :maxWidth="560">
      <div class="pc-dialog">
        <div class="pc-dialog-header">
          <div class="pc-dialog-header-left">
            <span class="pc-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.59 13.41l-7.18 7.18a2 2 0 0 1-2.82 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
            </span>
            <div>
              <h2 class="pc-dialog-title">Add Promo Code</h2>
              <p class="pc-dialog-sub">Create a runner-facing promo code with usage rules</p>
            </div>
          </div>
          <button class="pc-close-btn" @click="$modal.hide('addPromoCode')" title="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div class="pc-dialog-body">
          <div class="pc-error" v-if="invalidError">{{invalidMsg}}</div>
          <div class="pc-field">
            <label class="pc-label">Promo Code</label>
            <input class="pc-input" v-model="promoCodeData.code" @change="changeHandle">
          </div>
          <div class="pc-field-grid">
            <div class="pc-field">
              <label class="pc-label">Total Times Used</label>
              <input class="pc-input" v-model="promoCodeData.totalTimesUsed" @change="changeHandle">
            </div>
            <div class="pc-field">
              <label class="pc-label">Usage Limit</label>
              <input class="pc-input" v-model="promoCodeData.usageLimit" @change="changeHandle">
            </div>
          </div>
          <div class="pc-field">
            <label class="pc-label">Expiration Date</label>
            <date-time-field class="pc-date-field" v-model="promoCodeData.expirationDate" name="date"
              data-vv-value-path="startDate.time" data-vv-name="date"></date-time-field>
          </div>

          <div class="pc-field pc-tag-field">
            <label class="pc-label">Tag</label>
            <selectize v-bind:options="tagsOptions" v-model="selectedTags" multiple size="1"
              data-dropdown-parent="body" data-max-options="100" :isRunnerTag='false' :isRaceTag='false'
              data-value-field= 'id' data-label-field='name' data-search-field= 'name' data-sort-field= 'name'
              class="pc-selectize-hidden">
            </selectize>
          </div>
        </div>

        <div class="pc-dialog-footer">
          <button class="pc-cancel-btn" @click="$modal.hide('addPromoCode')">Cancel</button>
          <button class="pc-save-btn" v-on:click="Save()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/>
              <polyline points="7 3 7 8 15 8"/>
            </svg>
            Save
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue"
import DateField from '@/components/Forms/DateField'
import DateTimeField from '@/components/Forms/DateTimeField'
import PromoCodeService from "../../../../services/promoCode"
import Selectize from '@/components/Selectize'
import TagService from '../../../../services/tag'

export default {
  name: "add-promo-code",
  data: () => ({
   promoCodeData:{
      "code": "",
      "totalTimesUsed": 0,
      "usageLimit": "",
      "expirationDate": '',
      "tags": null,   
    },
    tagsOptions:[],
    selectedTags:[],
    invalidError:false,
    invalidMsg:''
  }),
  props: {
    show: false
  },
  methods: {
    changeHandle(){
      this.invalidError=false
      this.invalidMsg=""
    },
    onClose() {
      //EventBus.$emit('date','true')
      this.promoCodeData={
        "code": "",
        "totalTimesUsed": 0,
        "usageLimit": '',
        "expirationDate": '',
        "tags": null,   
      }
      this.selectedTags=[]
      this.$emit("closed", true)
    },
    openAddModal() {
      this.getAllTags()
      this.showError(false,"")
      this.$modal.show('addPromoCode')
    },
    showError(error,msg){
      this.invalidError=error
      this.invalidMsg=msg
    },
    Save() {    
        var tagList =[]
        this.selectedTags.forEach(tag => {
         // tagList.push({'id':parseInt(tag)})
          tagList.push(this.tagsOptions.find((e)=>e.id == parseInt(tag)))
        })
        this.promoCodeData.tags= tagList
        var that = this
        if(this.promoCodeData.code == ''){
           that.showError(true,"Please enter Promo Code")
           return
        }
        PromoCodeService.create(this.promoCodeData).then(response => {
          //console.log("response---",response)
              //this.$emit('saved', response.data)
              that.showError(false,"")
              that.$emit('saved')
              that.$modal.hide('addPromoCode')            
            }).catch(error => {
              console.log("err---",error)
              that.showError(true,error.data.description)
              //this.$refs.addLuckyRunner.close()
            }) 
     
               
    },
    getAllTags(){
      TagService.getAllTags().then((response)=>{
        //console.log("response----",response)
        this.tagsOptions = response.data    
      })
    },
  },
  created() {
    //this.getAllTags()
    //this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openAddModal()
      }
    }
  },
  components: {
    DateField,
    DateTimeField,
    Selectize
  }
}
</script>
<style>
.pc-modal .sweet-modal {
  border-radius: 14px;
  border: 1px solid #e8e8ed;
  box-shadow: 0 18px 45px rgba(20, 20, 35, 0.16);
  overflow: visible;
}

.pc-modal .sweet-content {
  padding: 0;
}

.pc-dialog {
  background: #fff;
  border-radius: 14px;
  overflow: visible;
}

.pc-dialog-header,
.pc-dialog-header-left,
.pc-dialog-footer,
.pc-save-btn,
.pc-cancel-btn,
.pc-close-btn {
  display: flex;
  align-items: center;
}

.pc-dialog-header {
  justify-content: space-between;
  gap: 16px;
  padding: 1.25rem 1.75rem;
  border-bottom: 1px solid #f0f0f5;
}

.pc-dialog-header-left {
  gap: 12px;
}

.pc-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.pc-dialog-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}

.pc-dialog-sub {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8a8a9a;
}

.pc-close-btn {
  width: 30px;
  height: 30px;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e8e8ed;
  background: #fff;
  color: #8a8a9a;
  cursor: pointer;
  transition: all 0.18s ease;
}

.pc-close-btn:hover {
  color: #c0392b;
  border-color: #f0b8b8;
  background: #fff1f1;
}

.pc-dialog-body {
  padding: 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.pc-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.pc-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.pc-label {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
}

.pc-input,
.pc-date-field .form-control,
.pc-dialog-body .text-field,
.pc-tag-field .selectize-input {
  width: 100%;
  min-height: 38px;
  border-radius: 8px;
  border: 1px solid #e8e8ed;
  background: #fafafa;
  padding: 0 12px;
  font-size: 13px;
  color: #1a1a2e;
  box-sizing: border-box;
}

.pc-tag-field .selectize-control {
  width: 100%;
}

.pc-selectize-hidden {
  visibility: hidden;
}

.pc-error {
  border: 1px solid #f2c7c1;
  border-radius: 8px;
  background: #fff6f4;
  color: #c0392b;
  font-size: 12px;
  padding: 9px 11px;
}

.pc-dialog-footer {
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #f0f0f5;
  padding: 1rem 1.75rem 1.5rem;
}

.pc-cancel-btn {
  height: 33px;
  padding: 0 16px;
  justify-content: center;
  border-radius: 7px;
  border: 1px solid #e0e0ea;
  background: #fff;
  color: #5b4fcf;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pc-save-btn {
  height: 36px;
  padding: 0 18px;
  justify-content: center;
  gap: 7px;
  border-radius: 8px;
  border: none;
  background: #5b4fcf;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pc-save-btn:hover {
  background: #4338ca;
}

@media (max-width: 640px) {
  .pc-dialog-header,
  .pc-dialog-body,
  .pc-dialog-footer {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }

  .pc-field-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// AddPromoCode.vue?408a59e0